import React from 'react'
import MobileNav from "./MobileNav"
import WebNav from "./Nav2"
import "./Nav.css"
function MainNav() {
  return (<>
  <div className="MobileNav">
        <MobileNav />
 </div>
 <div className="WebNav" >
        <WebNav />
 </div>
        </>
  
  )
}

export default MainNav